module.exports = __webpack_public_path__ + "img/avatar0.f5af52ee.png";